import { render } from "./CarCareTop.vue?vue&type=template&id=8e3b3f50"
import script from "./CarCareTop.vue?vue&type=script&lang=js"
export * from "./CarCareTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/CarCareTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e3b3f50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e3b3f50', __exports__)) {
    api.reload('8e3b3f50', __exports__)
  }
  
  module.hot.accept("./CarCareTop.vue?vue&type=template&id=8e3b3f50", () => {
    api.rerender('8e3b3f50', render)
  })

}


export default __exports__